export default __webpack_public_path__ + "static/media/PRATIK_SARDAR.61b6abe7.pdf";